module.exports = __webpack_public_path__ + "img/prize-2.dce4557f.png";